/* eslint-disable indent,no-new,no-undef */
import './bootstrap'
import router from './router'
import App from './App.vue'
import Vue from 'vue'
import './assets/scss/index.scss'
import 'animate.css/animate.css'
import 'trix/dist/trix.css'
import store from './store'

// import component and stylesheet
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

// see docs for available options
const datepickerOptions = {
  sundayFirst: true,
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  daysShort: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  colors: {
    selected: '#30AAE1',
    inRange: '#eaf8fe',
    text: '#73879c',
    inRangeBorder: '#eaf8fe',
    disabled: 'transparent',
    selectedText: '#fff'
  },
  texts: {
    apply: 'APPLY',
    cancel: 'CANCEL'
  }
}

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

Vue.directive('resultsCount', {
  inserted: function (el, binding) {
    el.classList.add('has-text-grey', 'is-size-7', 'margin-bottom-12')
    binding.def.calcAndSetText(binding.value, el)
  },
  update: function (el, binding) {
    let isChanged = false
    if (Array.isArray(binding.value)) {
      isChanged = JSON.stringify(binding.oldValue) !== JSON.stringify(binding.value)
    } else {
      isChanged = binding.oldValue !== binding.value
    }

    if (isChanged) {
      binding.def.calcAndSetText(binding.value, el)
    }
  },
  /**
   * Calculate text to be shown and show it
   *
   * @param {mixed} value Values
   * @param {DOM} el Element
   * @returns {void}
   */
  calcAndSetText (value, el) {
    if (Array.isArray(value)) {
      let html = `${value[0]} results`
      if (value[1] > -1) {
        html += ` of ${value[1]}`
      }
      el.innerHTML = html
    } else {
      el.innerHTML = `${value} results`
    }
  }
})

Vue.directive('tooltip', {
  /*
  Extend: placement
   */
  inserted (el, binding) {
    const tooltipElem = document.createElement('div')
    const id = 'tooltip-' + Date.now() + Math.random()
    tooltipElem.setAttribute('id', id)
    tooltipElem.setAttribute('class', `tooltip ${('isPopover' in binding.value && binding.value.isPopover) ? 'popover' : ''}`)
    tooltipElem.setAttribute('placement', binding.value.placement)
    tooltipElem.innerHTML = `<div class="tooltip-inner">${binding.value.content}</div><div class="tooltip-arrow ${('isPopover' in binding.value && binding.value.isPopover) ? 'popover-arrow' : ''}"></div>`
    document.body.appendChild(tooltipElem)
    el.setAttribute('data-tooltip-id', id)
    binding.def.addEvent(el, binding.value, tooltipElem)
  },
  update (el, binding, oldValue) {
    if (binding.oldValue.ref !== binding.value.ref) {
      const tooltipElem = document.getElementById(el.getAttribute('data-tooltip-id'))
      binding.def.addEvent(el, binding.value, tooltipElem)
    }
  },
  /**
   * Calculate and set tooltip position
   *
   * @param {DOM} el Element
   * @param {mixed} value Values
   * @param {DOM} tooltipElem Tooltip element
   * @returns {void}
   */
  addEvent (el, value, tooltipElem) {
    // Getting parent element where to place tooltip
    let refElem = el
    if ('ref' in value && value.ref) {
      refElem = document.getElementById(value.ref)
    }

    if (!Array.isArray(value.trigger)) {
      value.trigger = [value.trigger]
    }

    for (let val of value.trigger) {
      if (val === 'click') {
        refElem.addEventListener('click', event => {
          event.stopPropagation()
          this.toggleTooltip(refElem, tooltipElem)
        })
        tooltipElem.addEventListener('click', event => {
          event.stopPropagation()
        })
      } else if (val === 'hover') {
        refElem.addEventListener('mouseenter', () => {
          this.toggleTooltip(refElem, tooltipElem)
        })
        refElem.addEventListener('mouseleave', () => {
          this.toggleTooltip(refElem, tooltipElem, true)
        })
      }
    }
  },
  /**
   * Toggle tooltip
   *
   * @param {DOM} refElem Tooltip parent element
   * @param {DOM} tooltipElem Tooltip element
   * @param {Boolean} forceHide Force hide the tooltip element
   * @returns {void}
   */
  toggleTooltip (refElem, tooltipElem, forceHide = false) {
    if (tooltipElem.classList.contains('open') || forceHide) {
      tooltipElem.classList.remove('open')
    } else { // Set tooltip position in respect to parent element
      tooltipElem.classList.add('open')

      const refElemBound = refElem.getBoundingClientRect() // Getting parent element coordinates
      const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop // Page scrolled amount
      const tooltipElemBound = tooltipElem.getBoundingClientRect() // Tooltip coordinates
      tooltipElem.style.top = (refElemBound.top + scrollTop - tooltipElemBound.height - 7) + 'px' // (Position of parent element + Page scrolled)-Tooltip height
      tooltipElem.style.left = (refElemBound.left + refElemBound.width - tooltipElemBound.width + 13) + 'px'
    }
  }
})
document.body.addEventListener('click', (event) => {
  document.querySelectorAll('.tooltip').forEach(elem => {
    elem.classList.remove('open')
  })
})

// new vue instance
new Vue({
  el: '#app',
  store,
  router: router,
  render: h => h(App),
  watch: {
    '$route': () => {
      if (typeof window.Appcues !== 'undefined') {
        window.Appcues.page()
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js